<template>
  <div>
    <graph
      :title="adminText('workflowsAll.visitors_by_age_and_gender_8661b4a', 'Visitors by age and gender')"
      :data-filter="true"
      :value="false"
      :has-data="hasData"
      :initial-date-range-option="initialDateRangeOption"
      :initial-date-range="initialDateRange"
      @changeDateRange="changeDateRange($event)"
    >
      <div v-if="data.totalMale > 0 || data.totalFemale > 0" slot="value" class="header-title">
        <div class="female-circle" />
        <span class="gender-text-female">{{ workflowLabel(data.totalFemale) }} {{ adminText('workflowsAll.f_e69f20e', 'F') }}</span>
        <div class="male-circle" />
        <span class="gender-text-male">{{ workflowLabel(data.totalMale) }} {{ adminText('workflowsAll.m_c63ae6d', 'M') }}</span>
      </div>
      <bar-group-chart :data="workflowUi(data)" :options="workflowUi({})" />
    </graph>
  </div>
</template>
å
<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import { GET_EVENT_VISITOR_AGE_GENDER_STATS } from '../../../graphql/purchase.graphql'

import BarGroupChart from '../../shared/graphs/bar-group-chart.vue'
import Graph from '../../shared/graphs/graph.vue'
import moment from 'moment'
export default {
  mixins: [WorkflowDisplay],
  name: 'visitors-by-source-graph',
  components: {
    BarGroupChart,
    Graph,
  },
  props: ['eventId', 'initialDateRangeOption', 'initialDateRange', 'eventTemplateId'],
  data() {
    return {
      data: { datasets: [{ data: [] }] },
      endDate: this.initialDateRange[1],
      startDate: this.initialDateRange[0],
    }
  },
  computed: {
    hasData() {
      return this.data.totalMale > 0 || this.data.totalFemale > 0
    },
  },

  methods: {
    changeDateRange(dateRangeObject) {
      this.startDate = moment(dateRangeObject.dateRange[0]).format('YYYY-MM-DD')
      this.endDate = moment(dateRangeObject.dateRange[1]).format('YYYY-MM-DD')
      this.filterByDate()
    },
    async filterByDate() {
      await this.$apollo.queries.getEventVisitorAgeGenderStats.refetch()
    },
  },
  apollo: {
    getEventVisitorAgeGenderStats: {
      query: GET_EVENT_VISITOR_AGE_GENDER_STATS,
      variables() {
        return {
          from: this.startDate,
          to: this.endDate,
          eventId: this.eventId,
          eventTemplateId: this.eventTemplateId,
        }
      },
      result({ loading, data }) {
        if (!loading) {
          const {
            getEventVisitorAgeGenderStats: { male, female, totalMale, totalFemale },
          } = data
          this.data = {
            totalMale,
            totalFemale,
            labels: male.map(e => e.age),
            datasets: [
              {
                data: female.map(e => e.value),
              },
              {
                data: male.map(e => e.value),
              },
            ],
          }
        }
      },
    },
  },
}
</script>

<style scoped>
.header-title {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.female-circle {
  width: 12px;
  height: 12px;
  border-radius: 8.5px;
  background: #ff4c00;
}

.male-circle {
  width: 12px;
  height: 12px;
  border-radius: 8.5px;
  background: #0277bd;
  margin-left: 28px;
}

.gender-text-male {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 120%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #0277bd;
  margin-left: 12px;
}
.gender-text-female {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 120%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #ff4c00;
  margin-left: 12px;
}
</style>
